export function termsAndConditionsActions(termsAndConditionsAccepted, showCloseButton) {
    return {
        type: "TERMS_AND_CONDITIONS",
        termsAndConditionsAccepted: termsAndConditionsAccepted,
        showCloseButton: showCloseButton
    }
}
